import { ChevronRightIcon } from "@heroicons/react/20/solid";
import Link from "next/link";
import React from "react";

export interface CourseListItemProps {
  course: any;
}

const CourseListItem: React.FC<CourseListItemProps> = ({ course }) => {
  const { attributes } = course;
  return (
    <li>
      <Link
        href={`/cursos/${attributes.slug}`}
        className="block hover:bg-gray-50"
      >
        <div className="flex items-center px-4 py-4 sm:px-6">
          <div className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
            <div className="truncate">
              <div className="flex">
                <h3 className="whitespace-pre-wrap text-lg font-medium text-primary md:text-2xl">
                  {attributes.title}
                </h3>
              </div>
              <div className="flex">
                <p className="whitespace-pre-wrap text-sm text-gray-500">
                  {attributes.description}
                </p>
              </div>
            </div>
          </div>
          <div className="ml-5 flex-shrink-0">
            <ChevronRightIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </div>
        </div>
      </Link>
    </li>
  );
};

export default CourseListItem;
